import invariant from 'tiny-invariant'
import { fetchNonce } from 'hooks/use-nonce'
import { useMutation } from '@tanstack/react-query'

const CF_URL = process.env.NEXT_PUBLIC_CF_URL || process.env.VITE_CF_URL

invariant(CF_URL, 'NEXT_PUBLIC_CF_URL or VITE_CF_URL inside designer request is required')

export interface DesignerRequestData {
  fullName: string
  designerName: string
  productLinks: string
  portfolioLinks: string
  motivation: string
  referrerName?: string
  terms_and_conditions: boolean
}

export interface DesignerRequestResponse {
  success: string[]
}

export async function submitDesignerRequestFetcher(
  data: DesignerRequestData,
  t: (key: string) => string,
) {
  try {
    const nonce = await fetchNonce('admin_nonce_field')

    const formData = new URLSearchParams()
    formData.append('full_name', data.fullName)
    formData.append('shop_name', data.designerName)
    formData.append('shop_url', data.productLinks)
    formData.append('portfolio_url', data.portfolioLinks)
    formData.append('motivation', data.motivation)

    if (data.referrerName) {
      formData.append('contact_name', data.referrerName)
    }

    formData.append('terms_and_conditions', data.terms_and_conditions ? 'on' : '')
    formData.append('action', 'cf_ajax_designer_request')
    formData.append('security', nonce)

    const res = await fetch(`${CF_URL}/wp-admin/admin-ajax.php`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
      body: formData.toString(),
    })

    const textResponse = await res.text()

    try {
      const fetchData: DesignerRequestResponse = JSON.parse(textResponse)
      return fetchData
    } catch (error) {
      throw new Error(t('errors.invalid_response'))
    }
  } catch (error) {
    throw new Error(t('errors.submission_failed'))
  }
}

export function useDesignerRequest(t: (key: string) => string) {
  const designerRequestMutation = useMutation({
    mutationFn: async (data: DesignerRequestData) => {
      return await submitDesignerRequestFetcher(data, t)
    },
  })

  return designerRequestMutation
}
